import { Flex, SidePanel, Text } from "@wayflyer/flyui";
import type { FundingApplicationSchemas } from "api-types";
import { useIntl } from "react-intl";

import { getManualAirPanelBody, getManualAirTitle } from "./manual-air-card-content";

interface ManualAirDetailsPanelProps {
  air: FundingApplicationSchemas.ManualAdditionalInformationRequestSchema | null;
  open: boolean;
  onClose: () => void;
}

export const ManualAirDetailsPanel = ({ air, open, onClose }: ManualAirDetailsPanelProps) => {
  const intl = useIntl();

  if (!air) {
    return null;
  }

  const title = getManualAirTitle(intl, air);
  const body = getManualAirPanelBody(intl, air);

  return (
    <SidePanel open={open} isModal={false} onClose={onClose} title={title} variant="md" closeOnClickElseWhere>
      <Flex direction="column" gap="4">
        {body.split("\n\n").map((paragraph) => (
          <Text key={paragraph} color="placeholder">
            {paragraph}
          </Text>
        ))}
      </Flex>
    </SidePanel>
  );
};
